<template>
	<v-container class="noMargin">
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRIVS') !== -1">
			<v-flex lg12>
				<div class="pageTitle">
					<h2>PRIVILEGES</h2>					
				</div>
				<v-btn @click.prevent="fncAddPrivilege" class="elevation-5" color="info"><i class="material-icons">add</i>Create Privilege</v-btn>
				<v-btn @click.prevent="fncReloadPrivileges" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>		
    </v-container>	
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		  },
		methods: {
			fncAddPrivilege() {
				var modalDetails = { title: 'Add Privilege', component: 'modal-privilege-add', mstate: true, params: {} };			
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          },
            fncReloadPrivileges() {
              this.$store.dispatch({
                type: 'fncPopulatePrivList',
                reload: true
              })
            }
		},
		computed: {
			...mapGetters([			
				'objAuthorize'			
			])
		} 	
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>